var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckSquareSaved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5858 6.92953C11.8922 6.6509 11.9148 6.17657 11.6362 5.87007C11.3576 5.56358 10.8832 5.54099 10.5767 5.81962L7.09375 8.98598L5.78576 7.7969C5.47926 7.51827 5.00493 7.54085 4.7263 7.84735C4.44767 8.15384 4.47025 8.62818 4.77675 8.90681L6.58925 10.5545C6.87531 10.8146 7.31219 10.8146 7.59826 10.5545L11.5858 6.92953Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 0.187073C2.12665 0.187073 0 2.31372 0 4.93707V11.4371C0 14.0604 2.12665 16.1871 4.75 16.1871H11.25C13.8734 16.1871 16 14.0604 16 11.4371V4.93707C16 2.31372 13.8734 0.187073 11.25 0.187073H4.75ZM1.5 4.93707C1.5 3.14215 2.95507 1.68707 4.75 1.68707H11.25C13.0449 1.68707 14.5 3.14215 14.5 4.93707V11.4371C14.5 13.232 13.0449 14.6871 11.25 14.6871H4.75C2.95508 14.6871 1.5 13.232 1.5 11.4371V4.93707Z",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckSquareSaved);
export default __webpack_public_path__ + "static/media/iconCheckSquareSaved.c90bd74f.svg";
export { ForwardRef as ReactComponent };